import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Emprendedor_Dashboard from './pages/Emprendedor_Dashboard';
import Admin_Dashboard from './pages/Admin_Dashboard';
import Admin_CreateEventPage from './pages/Admin_CreateEventPage';
import Admin_UserManagement from './pages/Admin_UserManagement';
import Admin_RoleManagement from './pages/Admin_RoleManagement';
import BrowseEventsPage from './pages/BrowseEventsPage';
import EventDetailPage from './pages/EventDetailPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route element={<Layout />}>
            <Route path="/dashboard-emprendedor" element={<Emprendedor_Dashboard />} />
            <Route path="/dashboard-admin" element={<Admin_Dashboard />} />
            <Route path="/admin/crear-evento" element={<Admin_CreateEventPage />} />
            <Route path="/admin/usuarios" element={<Admin_UserManagement />} />
            <Route path="/admin/roles" element={<Admin_RoleManagement />} />
            <Route path="/eventos" element={<BrowseEventsPage />} />
            <Route path="/evento/:eventId" element={<EventDetailPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
